<script>
  import Menu from '@smui/menu';
  import Button, { Label, Icon } from '@smui/button';
  import List, { Item, Graphic, Meta, Text, PrimaryText } from '@smui/list';
  import Avatar from '$lib/client/shared/avatar.svelte';
  import Ripple from '@smui/ripple';
  import { invalidateAll, goto } from '$app/navigation';
  import { page } from '$app/stores';
  let menu;

  export async function signOut(options) {
    const { callbackUrl = window.location.href } = options ?? {};
    const basePath = '';
    const res = await fetch(`${basePath}/auth/signout`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Auth-Return-Redirect': '1'
      },
      body: new URLSearchParams({
        callbackUrl
      })
    });
    const data = await res.json();
    const url = data.url ?? callbackUrl;
    window.location.href = url;
    // If url contains a hash, the browser does not reload the page. We reload manually
    if (url.includes('#')) window.location.reload();
  }
</script>

<div use:Ripple={{ surface: true }} class="u-p-tiny">
  <Avatar  user={$page.data.session.user} size="tiny" on:click={() => menu.setOpen(true)} />
</div>
<Menu class="burger-menu" bind:this={menu}>
  <List>
    <Item>
      <a class="lined-up" href={`/profile/pledge`}>
        <Icon class="material-icons u-pr-small">savings</Icon>
        Pledges</a
      >
    </Item>

    <Item>
      <a class="lined-up" href={`/profile/favourites`}>
        <Icon class="material-icons u-pr-small">favorite</Icon>
        Favourites</a
      >
    </Item>

    <Item>
      <a class="lined-up" href={`/profile/shares`}>
        <Icon class="material-icons u-pr-small">share</Icon>
        Shares</a
      >
    </Item>

    {#each $page.data.session.user?.artists as artist}
      <Item>
        <a class="lined-up" href={`/artists/${artist.slug}`}>{artist.name} Artist Profile</a>
      </Item>
    {/each}
    <Item>
      <span class="lined-up" on:click={() => signOut()}>
        <Icon class="material-icons u-pr-small">logout</Icon>
        Sign Out</span
      ></Item
    >
  </List>
</Menu>
